// Types
import type { SelectOptionType } from "types"

export const invoiceStatusList: SelectOptionType[] = [
  {
    label: "Pending",
    value: "1"
  },
  {
    label: "Closed",
    value: "2"
  },
  {
    label: "Credit",
    value: "3"
  }
]